import { createGlobalStyle } from 'styled-components';
export const HideGlobalScrollbar = createGlobalStyle `
    body,
    html {
        overflow: hidden;
    }

    @media (min-width: 30rem) {
        body,
        html {
            overflow: auto;
        }
    }
`;
